/**
 * @deprecated - This property is being removed in V6+, February 2025
 */
export const gridSize = 4;
